export default "__VITE_ASSET__Q6yOCvmU__"